import React, { useState} from 'react';

const MobileAppSectionVideoFrame = () => {
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    const handlePlayVideo = () => {
        setIsVideoPlaying(true);
    }

    const handleVideoEnd = () => {
        setIsVideoPlaying(false);
        console.log('video ended');
    }

    return (
        <div className="mobileAppSectionVideoFrame__container">
            <div className="mobileAppSectionVideoFrame__container-wrap">
                <div className="mobileAppSectionVideoFrame__container-video-wrap">
                    <div className="mobileAppSectionVideoFrame__container-video">
                        <div className={`mobileAppSectionVideoFrame__container-video-background ${isVideoPlaying ? 'close' : 'open'}`}>
                            <div className="mobileAppSectionVideoFrame__container-video-background-img-wrap">
                                <img src={`${process.env.PUBLIC_URL}/images/video-load-image.png`} alt="mobile-app-background" />
                            </div>
                            <div className="mobileAppSectionVideoFrame__container-video-play-wrap">
                                <img
                                    className="mobileAppSectionVideoFrame__container-video-play-icon"
                                    src={`${process.env.PUBLIC_URL}/images/button-play-video.svg`}
                                    alt="play-icon"
                                    onClick={handlePlayVideo}
                                />
                            </div>
                        </div>
                        <iframe
                            className={`mobileAppSectionVideoFrame__container-video-iframe ${isVideoPlaying ? 'open' : 'close'}`}
                            src="https://www.youtube.com/embed/wxkGFd3B5AY"
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            onEnded={handleVideoEnd}
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileAppSectionVideoFrame;